import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const eur = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n || 0);

export function offerTotals(offer) {
  const subtotal = (offer.items || []).reduce(
    (s, i) => s + (Number(i.quantity) || 0) * (Number(i.unit_price) || 0), 0);
  const afterDiscount = subtotal - (subtotal * (Number(offer.discount_pct) || 0)) / 100;
  const tax = (afterDiscount * (Number(offer.tax_pct) || 0)) / 100;
  return { subtotal, afterDiscount, tax, total: afterDiscount + tax };
}

export default api;
